export const SCROLL_THROTTLE_TIME_MS = 20;
export const WINDOW_RESIZE_DEBOUNCE_MS = 100;

export enum RenderEvent {
  RE_RENDER = 'rerender',
  WINDOW_RESIZE = 'resize',
  WINDOW_SCROLL = 'scroll',
}
